module.exports = __webpack_public_path__ + "img/TechCavalryArm3_ua.920e1d56.webp";